module.exports = "/images/searchOrder.gif";